import { render, staticRenderFns } from "./FormPostoTrabalho.vue?vue&type=template&id=2afda578"
import script from "./FormPostoTrabalho.vue?vue&type=script&lang=js"
export * from "./FormPostoTrabalho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports